import script from "./ContactFormLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactFormLanding.vue?vue&type=script&setup=true&lang=js"

import "./ContactFormLanding.vue?vue&type=style&index=0&id=350745a1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350745a1"]])

export default __exports__